import React from "react";
import useGoToPricing from "../../hooks/useGoToPricing";
import Header from "../Homepage/sections/Header";
import Footer from "../Homepage/sections/Footer";
import { Page, HomepageGlobalStyles } from "../Homepage/styles";
import { isLoggedIn } from "../../utils/isLoggedIn";
import ProfilePage from "./ProfilePage";
import {
  ProfileGlow,
  ProfilePage as ProfilePageRoot,
  ProfileShell,
} from "./Profile.styles";

/**
 * Lovable User Profile shell + Homepage Header.
 * Tab behavior / APIs stay production (see panels + Billing).
 */
const Profile = () => {
  const goToPricing = useGoToPricing();
  const loggedIn = isLoggedIn();

  return (
    <Page>
      <HomepageGlobalStyles />
      <ProfilePageRoot>
        <ProfileGlow aria-hidden="true" />
        <ProfileShell>
          <Header onSubscribeClick={goToPricing} hideSpacer />
          <ProfilePage />
          <Footer onSubscribeClick={goToPricing} hideSubscribeCta={loggedIn} />
        </ProfileShell>
      </ProfilePageRoot>
    </Page>
  );
};

export default Profile;
